import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b4152e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "checked"]
const _hoisted_2 = { class: "ms-4" }

import { computed, CSSProperties, PropType } from 'vue'
import { SNS_SITE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  width: {
    type: Number,
    default: 36,
  },
  height: {
    type: Number,
    default: 24,
  },
  onStateChange: {
    type: Function as PropType<(obj) => void | any>,
    default: () => null,
  },
  snsName: {
    type: String,
    default: SNS_SITE.SNS_GOOGLE,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  onText: {
    type: String,
    default: '',
  },
  offText: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props


const toggleClick = () => {
  const cb: any = document.getElementById(`sns-toggle-${props.snsName}`)
  if (cb) {
    cb.checked = !cb.checked
  }
}

const dynamicSize: CSSProperties | any = computed(() => {
  const width = props.width
  const height = props.height
  return {
    '--my-width': `${width}px`,
    '--my-height': `${height}px`,
    '--transition': `${width - height}px`,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "switch",
      style: _normalizeStyle(_unref(dynamicSize))
    }, [
      _createElementVNode("input", {
        id: `sns-toggle-${__props.snsName}`,
        type: "checkbox",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onStateChange && __props.onStateChange(...args))),
        checked: __props.checked
      }, null, 40, _hoisted_1),
      _createElementVNode("span", {
        class: "slider round",
        onClick: toggleClick
      })
    ], 4),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.checked ? __props.onText : __props.offText), 1)
  ], 64))
}
}

})